
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Alert from 'vux/src/components/alert/index.vue'

import global from '../../../static/js/global.js'
import loadPage from '../../components/loadingPage'
import $ from 'jquery'
export default{
components: {
FlexboxItem,
Flexbox,
XHeader,
Group,
Cell,
XImg,
XInput,
PopupPicker,
XTextarea,
XButton,
Alert,
loadPage,
$
},
data(){
return{
imgs:[],
sellerName:'',
connectPerson:'',
mobile:'',
sellerPlace:'',
value1:[''],
list1:[[]],
value2:[''],
value3:[],
list2:[[]],
sayDetail:'',
keys:'',
showprompt:false,
prompt:"",
comnList:'',
moduleType:'',
scopeBusiness:'',
dmlist:'',
show_1:false,
text_1:'',
useragent:''
}
},
beforeMount(){
this.show_1 = false;
this.useragent = navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ? true : false;
let url = global.host + 'community/getList';
this.$http.get(url).then(function(res){
let mlist = res.body.result;
/*   let arr = new Array();
this.keys = new Object();*/
this.dmlist = res.body.result;
for(let s in mlist){
/*let json1 = {"comncode":mlist[s].comnCode};
this.value3.push(json1);*/
this.list2[0].push(mlist[s].comnName)

}

},function(err){
console.log(err)
})


let urls = global.host + 'dict/getParamsByDoMain/SELLER_PUBLISH_TYPE';
this.$http.get(urls).then(function(res){
let mtlist = res.body.result;
this.comnList = res.body.result;
/*let arr = new Array();
this.keys = new Object();*/

for(let s in mtlist){
this.list1[0].push(mtlist[s].pvalue)
}
this.show_1 = false;
},function(err){
console.log(err)
})
},
methods:{
add_img(event){
var reader =new FileReader();
var img1=event.target.files[0];
reader.readAsDataURL(img1);
var that=this;
reader.onloadend=function(event){
that.imgs.shift();

var img = new Image;

let width = 680, //图像大小
quality = 0.8, //图像质量
canvas = document.createElement("canvas"),
drawer = canvas.getContext("2d");
img.src = this.result;
img.onload = function () {
canvas.width = width;
canvas.height = width * (img.height / img.width);
drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
let imgBase64 = canvas.toDataURL("image/jpeg", quality);
that.imgs.push(imgBase64);
img.src="";
}

}
},
onChange(result){

for(let s in this.comnList){
if(result==this.comnList[s].pvalue){
this.moduleType = this.comnList[s].pkey;
}
}
},
changeRz(results){
for(let m in this.dmlist){
if(results == this.dmlist[m].comnName){
let json1 = {"comncode":this.dmlist[m].comnCode};
this.value3.push(json1);
console.log(this.value3)
}
}
},
change(){
console.log(1)
this.show = true;
},
sendAjax(){
let myreg=/^[1][3,4,5,7,8][0-9]{9}$/;
if($("#mId").find(".vux-cell-value").text() == ""){
this.showprompt = true;
this.prompt = "请选择入驻小区";
}else if(this.imgs == ""){
this.showprompt = true;
this.prompt = "请上传商家图片";
}else if(this.sellerName == ""){
this.showprompt = true;
this.prompt = "商家姓名不能为空";
}else if(this.connectPerson == ""){
this.showprompt = true;
this.prompt = "联系人不能为空";
}else if(this.mobile == ""){
this.showprompt = true;
this.prompt = "手机号不能为空";
}else if(!myreg.test(this.mobile)){
this.showprompt = true;
this.prompt = "请输入正确的手机号";
}else if(this.sellerPlace == ""){
this.showprompt = true;
this.prompt = "商家地址不能为空";
}else if(this.scopeBusiness == ""){
this.showprompt = true;
this.prompt = "经营范围不能为空";
}else if($("#selectTypes").find(".vux-cell-value").text() == ""){
this.showprompt = true;
this.prompt = "请选择分类";
}else if(this.sayDetail == ""){
this.showprompt = true;
this.prompt = "商家简介不能为空";
}else{
let json = {
"comnArray":JSON.stringify(this.value3),
"sellerTitle":this.sellerName,
"openId":this.$router.history.current.query.openid,
"comnCode":this.$router.history.current.query.comnCode,
"sellerIcon":this.imgs[0],
"telePhone":this.mobile,
"sellerAddr":this.sellerPlace,
"sellerContent":this.sayDetail,
"moduleType":this.moduleType,
"sellerDesc":this.scopeBusiness

}
console.log("&&&&&&&&&&&&&&&&&&&&")
console.log(json)
let url = global.host + 'merchant/entry';
this.$http.post(url,json).then(function(res){
console.log(res)
this.show_1 = false;
let resCode = res.body.msgcode;
if(resCode == "110"){
this.showprompt = true;
this.prompt = "申请已提交成功，正在审核中，请耐心等待...";
this.$router.push({path:'/myEnter',query:{}})
}else if(resCode == "120"){
this.showprompt = true;
this.prompt = "系统异常";
}else if(resCode == "130"){
this.showprompt = true;
this.prompt = '该商户正在审核中，请耐心等待！';
}else if(resCode == "140"){
this.showprompt = true;
this.prompt = '该商户已存在';
}
this.show_1 = false;
},function(err){
console.log(err)
})
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/convenientComponents/myEnter.vue